import {AccordionItemCustom as AccordionItem} from '@/components/molecules/AccordionItemCustom'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {LabelWithVal} from './LabelWithVal'

const PromotionsReviewAdditionalInformation = ({promotionReviewData}) => {
  const {isDuplicating} = usePromotion()

  return (
    <AccordionItem
      isDark
      size="large"
      className="min-h-12 w-full gap-2 rounded p-4"
      labelClassName="font-body text-base font-medium leading-normal"
      label={
        <div className="flex w-full items-center justify-between">
          <div className="font-medium">Additional Information</div>
        </div>
      }
      presentation="test"
      content={
        <div
          className="promotions-content-wrapper w-full overflow-hidden"
          style={{padding: '12px 16px', gap: '16px', minWidth: '1238px'}}
        >
          <div className="w-full overflow-hidden">
            <div className="grid w-full grid-cols-3 gap-6 overflow-hidden pb-5">
              <div className="overflow-hidden">
                <LabelWithVal keyName="Promotion ID" val={isDuplicating ? '-' : promotionReviewData?.id || '-'} />
              </div>
              <div className="overflow-hidden">
                <LabelWithVal
                  keyName="Promotion External ID"
                  val={isDuplicating ? '-' : promotionReviewData?.externalPromotionId || '-'}
                />
              </div>
              <div className="overflow-hidden">
                <LabelWithVal
                  keyName="External ID"
                  val={isDuplicating ? '-' : promotionReviewData?.externalId || '-'}
                />
              </div>
            </div>
            <div className="grid w-full grid-cols-3 gap-6 overflow-hidden pb-5">
              <div className="overflow-hidden">
                <LabelWithVal
                  keyName="Conditional External ID"
                  val={isDuplicating ? '-' : promotionReviewData?.conditionalExternalId || '-'}
                />
              </div>
              <div className="overflow-hidden">
                <LabelWithVal
                  keyName="Benefit External ID"
                  val={isDuplicating ? '-' : promotionReviewData?.benefitExternalId || '-'}
                />
              </div>
            </div>
          </div>
        </div>
      }
    />
  )
}

export default PromotionsReviewAdditionalInformation
